<div class="app-container" [class.is-mobile]="mobileQuery.matches">
    <mat-toolbar class="mat-elevation-z6">
        <button mat-icon-button (click)="toggled = !toggled">
            <mat-icon class="icon-100-hue">menu</mat-icon>
        </button>
        <span class="hoverable" [routerLink]="['/simulator-management/dashboard']"
            routerLinkActive="router-link-active">
            <img src="../assets/img/golftech-v2-whiteoutline.png" alt="Golf Tech Logo" height="70" />
        </span>
        <mat-chip-set *ngIf="this.user?.organizationName">
            <mat-chip highlighted="true"
                chipListSelectable="false">{{this.user?.organizationName}}</mat-chip>
        </mat-chip-set>
        <span class="spacer"></span>
        <button mat-icon-button [matMenuTriggerFor]="accountMenu">
            <mat-icon class="icon-100-hue">account_circle</mat-icon>
        </button>
        <span>{{user?.firstName}} {{user?.lastName}}</span>
        <mat-menu #accountMenu="matMenu">
            <ng-container *ngIf="user?.golfTechType === 5">
                <p *ngIf="user?.golfTechType === 5" class="gt-display-type">
                    {{golfTechTypeDisplayName(user?.golfTechType)}}
                </p>
                <hr />
            </ng-container>
            <button *ngIf="user?.golfTechType === 5" mat-menu-item
                [routerLink]="['/outing-management']">Outings</button>
            <button mat-menu-item [routerLink]="['/simulator-management/simulator-booking/my-account']">My
                Account</button>
            <button mat-menu-item (click)="logout()">Log Out</button>
            <mat-slide-toggle (change)="onToggleChange($event)" [checked]="isDarkTheme">Dark Theme</mat-slide-toggle>
        </mat-menu>
    </mat-toolbar>
    <mat-sidenav-container class="sidenav-container" [style.marginTop.px]="mobileQuery.matches ? 56 : 0">
        <mat-sidenav *ngIf="sessionService.isUserLoggedIn()" #sidenav [mode]="mobileQuery.matches ? 'over' : 'side'"
            [opened]="toggled" [fixedInViewport]="mobileQuery.matches" fixedTopGap="56"
            style="width: 250px">
            <mat-nav-list>
                <a mat-list-item [routerLink]="['/simulator-management/dashboard']" routerLinkActive="active-link"
                    [routerLinkActiveOptions]="{exact: true}"><mat-icon mat-list-icon>dashboard</mat-icon> Dashboard</a>
                <br />
                <mat-expansion-panel class="mat-elevation-z0"
                    [disabled]="!canAccess(this.user.permissions.reportingFunctionality)"
                    matTooltip="Please upgrade to use this feature"
                    [matTooltipDisabled]="canAccess(this.user.permissions.reportingFunctionality)">
                    <mat-expansion-panel-header><mat-icon>analytics</mat-icon>&nbsp;Reports</mat-expansion-panel-header>
                    <mat-nav-list dense>
                        <a mat-list-item [routerLink]="['/simulator-management/simulator-booking/reports/bookings']"
                            routerLinkActive="active-link" [routerLinkActiveOptions]="{exact: true}">Bookings</a>
                    </mat-nav-list>
                </mat-expansion-panel>
                <br />
                <mat-expansion-panel class="mat-elevation-z0">
                    <mat-expansion-panel-header><mat-icon>calendar_month</mat-icon>&nbsp;Booking</mat-expansion-panel-header>
                    <mat-nav-list dense>
                        <a mat-list-item [routerLink]="['/simulator-management/simulator-booking/scheduler-v2']"
                            routerLinkActive="active-link" [routerLinkActiveOptions]="{exact: true}">Scheduler</a>
                        <a mat-list-item [routerLink]="['/simulator-management/simulator-booking/bookings']"
                            routerLinkActive="active-link" [routerLinkActiveOptions]="{exact: true}">Bookings</a>
                        <a mat-list-item [routerLink]="['/simulator-management/simulator-booking/bookingwidget']"
                            routerLinkActive="active-link" [routerLinkActiveOptions]="{exact: true}">Widget</a>
                        <a mat-list-item [routerLink]="['/simulator-management/simulator-booking/addons']"
                            routerLinkActive="active-link" [routerLinkActiveOptions]="{exact: true}">Addons</a>
                        <a mat-list-item [routerLink]="['/simulator-management/simulator-booking/promo-codes']"
                            routerLinkActive="active-link" [routerLinkActiveOptions]="{exact: true}">Promo Codes</a>
                        <a mat-list-item [routerLink]="['/simulator-management/simulator-booking/scheduled-bookings']"
                            routerLinkActive="active-link" [routerLinkActiveOptions]="{exact: true}">Scheduled Bookings</a>
                    </mat-nav-list>
                </mat-expansion-panel>
                <br />
                <mat-expansion-panel class="mat-elevation-z0"
                [disabled]="!canAccess(this.user.permissions.leagueFunctionality)"
                matTooltip="Please upgrade to use this feature"
                [matTooltipDisabled]="canAccess(this.user.permissions.leagueFunctionality)">
                    <mat-expansion-panel-header><mat-icon>groups</mat-icon>&nbsp;League</mat-expansion-panel-header>
                    <mat-nav-list dense>
                        <a mat-list-item [routerLink]="['/simulator-management/simulator-booking/leagues']"
                            routerLinkActive="active-link" [routerLinkActiveOptions]="{exact: true}">Leagues</a>
                        <a mat-list-item [routerLink]="['/simulator-management/simulator-booking/league-members']"
                            routerLinkActive="active-link" [routerLinkActiveOptions]="{exact: true}">Members</a>
                    </mat-nav-list>
                </mat-expansion-panel>
                <br />
                <mat-expansion-panel class="mat-elevation-z0">
                    <mat-expansion-panel-header><mat-icon>sports_golf</mat-icon>&nbsp;Simulator</mat-expansion-panel-header>
                    <mat-nav-list dense>
                        <a mat-list-item [routerLink]="['/simulator-management/simulator-booking/simulators']"
                            routerLinkActive="active-link" [routerLinkActiveOptions]="{exact: true}">Simulators</a>
                        <a mat-list-item [routerLink]="['/simulator-management/simulator-booking/price-bands']"
                            routerLinkActive="active-link" [routerLinkActiveOptions]="{exact: true}">Price Bands</a>
                        <a mat-list-item [routerLink]="['/simulator-management/simulator-booking/prices']"
                            routerLinkActive="active-link" [routerLinkActiveOptions]="{exact: true}">Prices</a>
                    </mat-nav-list>
                </mat-expansion-panel>
                <br />
                <mat-expansion-panel class="mat-elevation-z0">
                    <mat-expansion-panel-header><mat-icon>description</mat-icon>&nbsp;Digital
                        Waiver</mat-expansion-panel-header>
                    <mat-nav-list dense>
                        <a mat-list-item [routerLink]="['/simulator-management/simulator-booking/digital-waivers']"
                            routerLinkActive="active-link" [routerLinkActiveOptions]="{exact: true}">Waivers</a>
                        <a mat-list-item
                            [routerLink]="['/simulator-management/simulator-booking/digital-waiver-entries']"
                            routerLinkActive="active-link" [routerLinkActiveOptions]="{exact: true}">Entries</a>
                    </mat-nav-list>
                </mat-expansion-panel>
                <br />
                <mat-expansion-panel class="mat-elevation-z0"
                    [disabled]="!canAccess(this.user.permissions.membershipFunctionality)"
                    matTooltip="Please upgrade to use this feature"
                    [matTooltipDisabled]="canAccess(this.user.permissions.membershipFunctionality)">
                    <mat-expansion-panel-header><mat-icon>card_membership</mat-icon>
                        &nbsp;Membership</mat-expansion-panel-header>
                    <mat-nav-list dense>
                        <a mat-list-item [routerLink]="['/simulator-management/simulator-booking/membership-plans']"
                            routerLinkActive="active-link" [routerLinkActiveOptions]="{exact: true}">Plans</a>
                        <a mat-list-item [routerLink]="['/simulator-management/simulator-booking/membership-customers']"
                            routerLinkActive="active-link" [routerLinkActiveOptions]="{exact: true}">Customers</a>
                        <a mat-list-item
                            [routerLink]="['/simulator-management/simulator-booking/bookingmembershipwidget']"
                            routerLinkActive="active-link" [routerLinkActiveOptions]="{exact: true}">Booking Widget</a>
                        <a mat-list-item
                            [routerLink]="['/simulator-management/simulator-booking/membershipcustomerwidget']"
                            routerLinkActive="active-link" [routerLinkActiveOptions]="{exact: true}">Customer Widget</a>
                    </mat-nav-list>
                </mat-expansion-panel>
                <br />
                <mat-expansion-panel class="mat-elevation-z0"
                    [disabled]="!canAccess(this.user.permissions.supportFunctionality)"
                    matTooltip="Please upgrade to use this feature"
                    [matTooltipDisabled]="canAccess(this.user.permissions.supportFunctionality)">
                    <mat-expansion-panel-header><mat-icon>support_agent</mat-icon>&nbsp;Support</mat-expansion-panel-header>
                    <mat-nav-list dense>
                        <a mat-list-item href="https://golftech.atlassian.net/servicedesk/customer/portal/1"
                            target="_blank">Submit a Ticket</a>
                    </mat-nav-list>
                </mat-expansion-panel>
            </mat-nav-list>
        </mat-sidenav>
        <mat-sidenav-content>
            <router-outlet></router-outlet>
        </mat-sidenav-content>
    </mat-sidenav-container>
</div>